import React, { useEffect, useState } from "react";
import moment from "moment";
import { Event, Notifications, StayCurrentLandscape } from "@material-ui/icons";
import { Badge, Button, Fade, Hidden, IconButton } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import * as ROUTES from "../../constants/routes";

const OnsiteTrainingButton = ({ user }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const [onSiteTrainingAvailable, setOnSiteTrainingAvailable] = useState(false);

  useEffect(() => {
    const OnsiteTrainingInfo = user?.sgpfc?.onSiteTrainings?.forms;

    let t = !!OnsiteTrainingInfo
      ? Object.keys(OnsiteTrainingInfo)
          .map((k) =>
            moment().isBetween(moment(OnsiteTrainingInfo[k].startDay, "DD/MM/YYYY"), moment(OnsiteTrainingInfo[k].endDay, "DD/MM/YYYY"), undefined, "[]")
              ? !OnsiteTrainingInfo[k].isReviewed
              : false
          )
          .reduce((pre, cur) => pre || cur, false)
      : false;
    setOnSiteTrainingAvailable(t);
  }, [user]);

  return (
    <Fade in={onSiteTrainingAvailable}>
      <IconButton
        disabled={!onSiteTrainingAvailable}
        style={{ color: "white" }}
        onClick={() => {
          history.push(ROUTES.ONSITE_TRAINING);
        }}
      >
        <Badge badgeContent={1} color="secondary">
          <Event fontSize="default" />
        </Badge>
      </IconButton>
    </Fade>
  );
};

export default OnsiteTrainingButton;
